<script lang="ts">
    import {ChevronDownOutline, ChevronUpOutline} from "flowbite-svelte-icons";
    import {Button} from "flowbite-svelte";

    export let title: string;
    export let icon = "";
    export let className = "";
    export let accordion = false;
    export let display = true;
</script>

<div class="flex flex-col bg-white rounded-lg shadow-sm
    min-w-[24em] h-min
    text-gray-600 dark:bg-gray-800 dark:text-gray-200
    border overflow-x-clip{className}">
    <div class="flex gap-5 flex-row justify-between mx-4 py-3 cursor-pointer  {display ? 'border-b' : ''}" >
        <div class="flex flex-row items-center gap-3 text-base font-semibold text-gray-900 leading-6 flex-1">
            {#if icon}
                <iconify-icon {icon} class="w-4"/>
            {/if}
            <h3 class="text-xl leading-7 text-gray-500 py-1 px-2 font-extralight">{title}</h3>

        </div>
        <slot name="card-header"/>
        {#if accordion}
            <Button class="!p-2" pill outline on:click={() => display = !display}>
                {#if display}
                    <ChevronUpOutline class="w-4 h-4" />
                {:else}
                    <ChevronDownOutline class="w-4 h-4" />
                {/if}
            </Button>
        {/if}
    </div>
    {#if display}
        <div class="flex flex-col gap-2 px-4 pb-4 pt-5 divide-y">
            <slot/>
        </div>
    {/if}
</div>
